export const MTM_SUBMIT_FEEDBACK = 'app/CommercialV2/MomentPage/SUBMIT_FEEDBACK';
export const MOMENT_PAGE_LOADED = 'app/CommercialV2/MomentPage/MOMENT_PAGE_LOADED';
export const talkspaceURL = 'https://www.talkspace.com/';
